import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpLoginRequest } from 'app/models/http-login-request';
import { VerificationResult } from 'app/models/verification-result.enum';
import { WebUserLoginAttemptInfo } from 'app/models/webuser-login-attempt-Info';
import { AppUtilService } from 'app/services/app-util.service';
import { AuthenticationService } from 'app/services/authentication.service';
import { Subscription, timer } from 'rxjs';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'verify',
  templateUrl: './verify.template.html',
  styleUrls: ['../app.scss', '../login/login.template.scss'],
  animations: [
    trigger('resendCodeAnimator', [
      state('true' , style({ opacity: 1 })),
      state('false', style({ opacity: 0 })),
      transition('0 => 1', animate('.5s')),
      transition('1 => 0', animate('.9s'))
    ])
  ]
})
export class VerifyComponent implements OnInit, OnDestroy {
  @ViewChild('verifyInput', {read: MatInput}) verifyInput: MatInput;
  public oneTimePasscodeInput: string;
  public dontAskCheckBox = false; //Default to unchecked per marketing 02/12/25
  public email: string;
  public verificationResult: VerificationResult;
  public unsuccessfulLoginCounter = 0;
  public remainingLockoutTime = 600;
  public timer: any;
  public failedAttempt = false;
  public subscription: Subscription;
  public isLoading = false;
  public resendLoading = false;
  public isResendCodeAnimationNeeded = false;
  public isResendAttemptUsed: boolean = false;
  public successMessage: string = '';
  public errorMessage: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private appUtil: AppUtilService) {
    if (this.authService.request) {
      this.email = this.authService.request.userLogin;
    }
  }

  public ngOnInit() {
    this.appUtil.setTitle('Two-Step Verification');
    this.isLoading = false;
    this.resendLoading = false;
    this.isResendCodeAnimationNeeded = false;
    const fail: string = this.route.snapshot.params['fail'];
    this.failedAttempt = fail ? true : false;
    if (this.failedAttempt) {
      this.loginFailedAttempt();
    }
    // if browser is refresh redirect back to the login page
    // if (!this.authService.request) {
    //   this.router.navigate(['login']);
    // }
  }

  public ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public focusInput(): void {
    if (this.verifyInput) {
      this.verifyInput.focus();
    }
  }

  private loginFailedAttempt(): void {
    if (!this.authService.request) {
      // this.router.navigate(['login']);
    } else {
      this.authService.getLoginAttempt().subscribe(data => {
        const loginAttemptInfo: WebUserLoginAttemptInfo = data;
        if (loginAttemptInfo) {
          this.unsuccessfulLoginCounter = loginAttemptInfo.unsuccessfulLoginCounter;
          this.remainingLockoutTime = loginAttemptInfo.remainingLockoutTime;
          if (this.unsuccessfulLoginCounter > 3) {
            this.createLockOutCounter();
          }
        }
      },
      err => {
        console.error(err);
      });
    }
  }

  onSubmit() {
    if (!this.authService.request) {
      // this.router.navigate(['login']);
    } else {
      const request: HttpLoginRequest = this.authService.request;
      request.dontAskCheckBox = this.dontAskCheckBox;
      this.authService.request = request;

      if (this.oneTimePasscodeInput) {
        this.isLoading = true;
        this.authService.verifyOneTimePasscodeEnteredIsValid(this.oneTimePasscodeInput).subscribe((verification: VerificationResult) => {
          this.verificationResult = verification;
          if (verification === VerificationResult.SESSIONEXPIRED) {
            this.router.navigate(['sessionExpired']);
          } else if (verification === VerificationResult.SUSPENDED) {
            this.router.navigate(['suspended'], { queryParams: { email: this.authService.request.userLogin } });
          } else if (verification !== VerificationResult.SUCCESS) {
            if (!this.failedAttempt) {
              this.router.navigate(['verify/fail']);
            } else {
              this.isLoading = false;
              this.loginFailedAttempt();
            }
          } else {
            const username = this.authService.request.userLogin;
            const password = this.authService.jpassword;
            this.authService.userLogin(username, password)
              .subscribe(data => {
                  this.authService.setChatRequirements();
                  window.location.href = decodeURIComponent(data.url);
            },
            err => {
              console.error(err);
            });
          }
        },
        err => {
          console.error(err);
        });
      }
    }
  }

  onResend() {
    if (this.authService.request) {
      this.isResendAttemptUsed = true;
      this.resendLoading = true;
      this.isResendCodeAnimationNeeded = true;
      this.authService.resendCode().subscribe((data: VerificationResult) => {
        if (data === VerificationResult.SUCCESS) {
          // display successful
          this.successMessage = 'Resend Successful';
        } else {
          // display failed!
          this.errorMessage = 'Unable to resend verification code';
        }
        let resendCtr = 2;
        const fadeOutTimer: any = timer(1000, 1000);
        const fadeOutSubscription: Subscription = fadeOutTimer.subscribe((tick) => {
            resendCtr -= 1;
            if (resendCtr < 1) {
              fadeOutSubscription.unsubscribe();
              this.resendLoading = false;
              this.isResendCodeAnimationNeeded = false;
            }
        });
      },
      err => {
        console.error(err);
      });
    }
  }

  private createLockOutCounter(): void {
    this.timer = timer(1000, 1000);
    this.subscription = this.timer.subscribe(tick => this.ticker());
  }

  private ticker(): void {
    this.remainingLockoutTime -= 1;
    if (this.remainingLockoutTime < 1) {
      this.subscription.unsubscribe();
      // this.router.navigate(['login']);
    }
  }

}
